<template>
    <rkm-modal
        :title="readonly ? 'Dados da atualização' : (local.index !== null ? 'Edição de atualização' : 'Nova atualização')"
        extra-large
        ref="RkmModal"
    >
        <rkm-form
            v-if="local"
            :show-legend="readonly ? false : true"
            ref="RkmForm"
        >
            <template v-if="readonly">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input
                            :value="local.unidadeNomeFantasia"
                            disabled
                            label="Unidade"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input
                            :value="local.salaVacinacaoNome"
                            disabled
                            label="Sala de vacinação"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input
                            :value="local.aplicador.cidadaoCns ? `${this.formatCns(local.aplicador.cidadaoCns)} - ${local.aplicador.cidadaoNome}` : `${local.aplicador.cidadaoNome}`"
                            disabled
                            label="Registrador por"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            :value="local.dataRegistro"
                            disabled
                            label="Data"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="cidadaoIdade"
                            disabled
                            label="Idade na data da aplicação"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row
                    v-if="additionals.salaVacinacaoLogada.criaFichaAb"
                >
                    <rkm-col>
                        <rkm-form-select
                            disabled
                            label="Ocupação"
                            :options="form.ocupacoes"
                            v-model="local.ocupacaoId"
                            :validations="validations.ocupacao"
                            text-field="codigoNome"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            disabled
                            label="Equipe"
                            :options="form.equipes"
                            v-model="local.equipeId"
                            :validations="validations.equipe"
                            text-field="descricao"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            disabled
                            label="Turno"
                            :options="form.turnos"
                            v-model="local.turnoId"
                            :validations="validations.turno"
                            text-field="nome"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            disabled
                            label="Local de atendimento"
                            :options="form.locais"
                            v-model="local.localAtendimentoId"
                            :validations="validations.localAtendimento"
                            text-field="descricao"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>
                <rkm-row>
                    <rkm-col cols="8">
                        <rkm-form-input
                            :value="inputVacinaValue"
                            disabled
                            label="Vacina"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :value="local.lote"
                            disabled
                            label="Lote"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-input
                        :value="local.estrategiaNome"
                        disabled
                        label="Estratégia"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                        :value="local.doseNome"
                        disabled
                        label="Dose"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :value="local.grupoAtendimentoNome"
                            disabled
                            label="Grupo de atendimento"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            :value="local.observacao"
                            readonly
                            label="Observação"
                            rows="4"
                        />
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-else>
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="additionals && additionals.salaVacinacaoLogada && !additionals.salaVacinacaoLogada.responsavel"
                            :options="form.unidades"
                            :validations="validations.unidadeId"
                            @change="handleUnidadeIdDeChange"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="local.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!local.unidadeId || (additionals && additionals.salaVacinacaoLogada && !additionals.salaVacinacaoLogada.responsavel)"
                            :options="form.salasVacinacao"
                            :validations="validations.salaVacinacaoId"
                            @change="handleSalaVacinacaoIdChange"
                            label="Sala de vacinação"
                            show-default-option
                            text-field="nome"
                            v-model="local.salaVacinacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input-autocomplete
                            :disabled="disableAplicador || !local.salaVacinacaoId"
                            :repository="repositories.usuario"
                            :request-query-string-params="{ aplicador: true, sala_vacinacao_id: local.salaVacinacaoId }"
                            :search-fields="fields.autocomplete.aplicador"
                            :text-field="(item) =>  item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                            :validations="validations.aplicador"
                            label="Registrado por"
                            v-model="local.aplicador"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :disabled="!local.salaVacinacaoId"
                            :max-date="others.moment(additionals.dataAtual, 'YYYY-MM-DD').format('DD/MM/YYYY')"
                            :min-date="others.moment(model.cidadaoDataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY')"
                            :validations="validations.dataRegistro"
                            label="Data"
                            v-model="local.dataRegistro"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input
                            :value="cidadaoIdade"
                            disabled
                            label="Idade na data da aplicação"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row
                    v-if="additionals.salaVacinacaoLogada.criaFichaAb"
                >
                    <rkm-col>
                        <rkm-form-select
                            label="Ocupação"
                            :options="form.ocupacoes"
                            v-model="local.ocupacaoId"
                            :validations="validations.ocupacao"
                            text-field="codigoNome"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Equipe"
                            :options="form.equipes"
                            v-model="local.equipeId"
                            :validations="validations.equipe"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            label="Turno"
                            :options="form.turnos"
                            v-model="local.turnoId"
                            :validations="validations.turno"
                            text-field="nome"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="form.locais"
                            v-model="local.localAtendimentoId"
                            :validations="validations.localAtendimento"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="8">
                        <rkm-form-input-autocomplete
                            :disabled="!local.salaVacinacaoId"
                            :repository="repositories.vacina"
                            :request-query-string-params="{origem: 'atualizacao', cria_ficha_ab: additionals.salaVacinacaoLogada.criaFichaAb}"
                            :search-fields="fields.autocomplete.vacina"
                            :text-field="item => item.id ? `${autocompleteTextField(item)}` : item.nome"
                            :validations="validations.vacina"
                            @input="handleVacinaInput"
                            @select="handleVacinaSelect"
                            label="Vacina"
                            v-model="local.vacina"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :disabled="!local.vacina"
                            label="Lote"
                            v-model="local.lote"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :disabled="true"
                            :validations="validations.produtor"
                            label="Produtor"
                            v-model="local.produtor"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="!local.vacina"
                            :options="form.estrategias"
                            :validations="validations.estrategiaId"
                            label="Estratégia"
                            show-default-option
                            text-field="nome"
                            v-model="local.estrategiaId"
                            value-field="id"
                        />

                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            v-if="additionals.salaVacinacaoLogada.criaFichaAb"
                            :disabled="!local.vacina"
                            :options="form.doses"
                            :validations="validations.doseId"
                            label="Dose"
                            show-default-option
                            text-field="nome"
                            v-model="local.doseId"
                            value-field="id"
                        />

                        <rkm-form-select
                            v-else
                            :disabled="!form.doses"
                            :options="form.doses"
                            :validations="validations.doseId"
                            label="Dose"
                            show-default-option
                            text-field="nome"
                            v-model="local.doseId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="disabledGrupoAtendimento"
                            :options="form.gruposAtendimento"
                            :validations="validations.grupoAtendimentoId"
                            label="Grupo de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="local.grupoAtendimentoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            :validations="validations.observacao"
                            label="Observação"
                            rows="4"
                            v-model="local.observacao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-table
                            :fields="fields.atualizacao"
                            :items="Array.isArray(model.registros) ? model.registros.filter(registro => registro.id == null && registro.registroTipo == 'atualizacao') : []"
                            hide-pagination
                            hide-filters
                        >
                            <template v-slot:cell(registroTipo)="{ item }">
                                <template v-if="item.registroTipo === 'aplicacao'">Aplicação</template>
                                <template v-else>Atualização</template>
                            </template>

                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Fechar
            </rkm-button>

            <rkm-button
                v-if="!readonly"
                :disabled="!!loading"
                @click="include"
                color="primary"
            >
                {{ local.id != null ? 'Salvar' : 'Incluir' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'
import turno from '@/enums/geral/turno'
import localAtendimento from '@/enums/atencao-basica/marcador-consumo-alimentar/localAtendimento'

// Mixins.
import { error, formats, repository, stringCase } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {
            const autocomplete = {
                aplicador: [
                    { key: 'cadastroCidadao.nome', searchable: true },
                ],
                vacina: [],
            }

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    autocomplete.vacina.push({ key: 'abreviacao', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    autocomplete.vacina.push({ key: 'sigla', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    autocomplete.vacina.push({ key: 'sigla', searchable: true })
                    autocomplete.vacina.push({ key: 'nome', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    autocomplete.vacina.push({ key: 'sigla', searchable: true })
                    autocomplete.vacina.push({ key: 'abreviacao', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    autocomplete.vacina.push({ key: 'abreviacao', searchable: true })
                    autocomplete.vacina.push({ key: 'nome', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    autocomplete.vacina.push({ key: 'sigla', searchable: true })
                    autocomplete.vacina.push({ key: 'abreviacao', searchable: true })
                    autocomplete.vacina.push({ key: 'nome', searchable: true })
                    break;

                default:
                    autocomplete.vacina.push({ key: 'nome', searchable: true })
                    break;
            }

            const commonFields = []
            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    commonFields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    commonFields.push({ key: 'vacinaSigla', label: 'Sigla da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    commonFields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    commonFields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    commonFields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    commonFields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina' })
                    break;

                default:
                    commonFields.push({ key: 'vacinaNome', label: 'Nome da vacina' })
                    break;
            }

            return {
                autocomplete,
                atualizacao: [
                    { key: 'registroTipo', label: 'Tipo de registro' },
                    ...commonFields,
                    { key: 'doseNome', label: 'Dose' },
                    {
                        key: 'dataRegistro',
                        label: 'Data',
                        formatter: (value) => {
                            return value ? value.split('-').reverse().join('/') : '';
                        }
                    },
                    { key: 'unidadeNomeFantasia', label: 'Unidade' },
                    { key: 'salaVacinacaoNome', label: 'Sala de vacinação' },
                    { key: 'observacao', label: 'Observação' },
                ]
             }
        },
        validations() {
            return {
                unidadeId: { required: true },
                salaVacinacaoId: { required: true },
                aplicador: { required: true },
                ocupacao: { required: true },
                estrategiaId: { required: true },
                equipe: { required: true },
                turno: { required: true },
                localAtendimento: { required: true },
                dataRegistro: { required: true },
                vacina: { required: true },
                produtor: { required: true },
                doseId: { required: true },
                observacao: { min: 3, max: 5000 },
            }
        },
        cidadaoIdade() {
            const dataNascimento = moment(this.model.cidadaoDataNascimento)

            if (this.local.dataRegistro) {
                const anos = moment(this.local.dataRegistro).diff(dataNascimento, 'years', false)
                const meses = moment(this.local.dataRegistro).diff(dataNascimento.add(anos, 'years'), 'months', false)
                const dias = moment(this.local.dataRegistro).diff(dataNascimento.add(meses, 'months'), 'days', false)

                return `${anos}a, ${meses}m e ${dias}d`
            }

            return null
        },
        inputVacinaValue() {
            let value = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    value = this.local.vacina.abreviacao
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    value = this.local.vacina.sigla
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    value = this.local.vacina.siglaNome
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    value = this.local.vacina.siglaAbreviacao
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    value = this.local.vacina.abreviacaoNome
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    value = this.local.vacina.siglaAbreviacaoNome
                    break;

                default:
                    value = this.local.vacina.nome
                    break;
            }

            return value
        },
        autocompleteVacinaTextField() {
            let textField = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.ABREVIACAO:
                    textField = 'abreviacao'
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    textField = 'sigla'
                    break;

                default:
                    textField = 'nome'
                    break;
            }

            return textField
        },
        disabledGrupoAtendimento() {
            if(!this.local.salaVacinacaoId) {
                return true
            }
            if (!this.local.vacina) {
                return true
            }
            return false
        },
        estrategiaNome() {
            return this.local.estrategiaNome || 'Não Informado';
        }
    },
    created() {
        this.repositories = {
            registroVacinacao: this.getConectaSusRepository('imunizacao.registroVacinacao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            vacina: this.getConectaSusRepository('cadastro.vacina'),
            fichaVacinacao: this.getConectaSusRepository('atencaoBasica.fichaVacinacao'),
        }
    },
    data: () => ({
        enums: {
            parametrizacaoDescricaoVacina,
            turno,
            localAtendimento
        },
        local: {
            aplicador: null,
            dataRegistro: null,
            doseId: null,
            doseNome: null,
            equipeId: null,
            estrategia: null,
            estrategiaId: null,
            estrategiaNome: null,
            grupoAtendimentoId: null,
            grupoAtendimentoNome: null,
            index: null,
            localAtendimentoId: null,
            localAtendimentoNome: null,
            lote: null,
            observacao: null,
            ocupacaoId: null,
            produtor: 'Não Informado',
            produtorId: null,
            produtorNome: null,
            salaVacinacaoId: null,
            salaVacinacaoNome: null,
            turnoId: null,
            turnoNome: null,
            unidadeId: null,
            unidadeNomeFantasia: null,
            vacina: null,
        },
        others: { moment },
        readonly: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getTurno() {
            const now = moment()
            if(now.hour() >= 6 && now.hour() <= 11) {
                return this.enums.turno.MANHA
            }
            if(now.hour() >= 12 && now.hour() <= 17) {
                return this.enums.turno.TARDE
            }
            return this.enums.turno.NOITE
        },
        open(item, readonly = false, index = null) {
            this.resetForm()

            this.readonly = readonly
            this.local.index = index

            this.local.id = null
            if (item) {
                this.local.id = item.id
                if (readonly === false) {
                    Promise.all([
                        this.getUnidades(),
                        this.getSalasVacinacao(item.unidadeId),
                        this.getDoses(item.vacinaId),
                        this.getEstrategias(item.vacinaId),
                    ]).then(() => {
                        this.local.unidadeId = item.unidadeId
                        this.local.unidadeNomeFantasia = item.unidadeNomeFantasia
                        this.local.salaVacinacaoId = item.salaVacinacaoId
                        this.local.salaVacinacaoNome = item.salaVacinacaoNome
                        this.local.aplicador = {
                            id: item.aplicadorId,
                            cidadaoNome: item.aplicadorNome,
                            cidadaoCns: item.aplicadorCns,
                        }
                        this.local.ocupacaoId = item.ocupacaoId
                        this.local.equipeId = item.equipeId
                        this.local.turnoId = item.turnoId
                        this.local.localAtendimentoId = item.localAtendimentoId
                        this.local.dataRegistro = this.others.moment(item.dataRegistro).toDate()
                        this.local.vacina = {
                            id: item.vacinaId,
                            nome: item.vacinaNome,
                            abreviacao: item.vacinaAbreviacao,
                            sigla: item.vacinaSigla,
                            siglaNome: `${item.vacinaSigla} - ${item.vacinaNome}`,
                            siglaAbreviacao: `${item.vacinaSigla} - ${item.vacinaAbreviacao}`,
                            abreviacaoNome: `${item.vacinaAbreviacao} - ${item.vacinaNome}`,
                            siglaAbreviacaoNome: `${item.vacinaSigla} - ${item.vacinaAbreviacao} -
                                ${item.vacinaNome}`,
                        }
                        this.local.grupoAtendimentoId = item.grupoAtendimentoId
                        this.local.grupoAtendimentoNome = item.grupoAtendimentoNome
                        this.local.doseId = item.doseId
                        this.local.doseNome = item.doseNome
                        this.local.estrategiaId = item.estrategiaId
                        this.local.estrategiaNome = item.estrategiaNome
                        this.local.observacao = item.observacao
                        this.local.lote = item.lote
                            ? (typeof item.lote === 'object' && item.lote !== null ? item.lote.lote : item.lote)
                            : null;

                        this.$refs.RkmModal.show()
                    })
                } else {
                    this.local.unidadeId = item.unidadeId
                    this.local.unidadeNomeFantasia = item.unidadeNomeFantasia
                    this.local.salaVacinacaoId = item.salaVacinacaoId
                    this.local.salaVacinacaoNome = item.salaVacinacaoNome
                    this.local.aplicador = {
                        id: item.aplicadorId,
                        cidadaoNome: item.aplicadorNome,
                        cidadaoCns: item.aplicadorCns,
                    }
                    this.local.ocupacaoId = item.ocupacaoId
                    this.local.equipeId = item.equipeId
                    this.local.turnoId = item.turnoId
                    this.local.localAtendimentoId = item.localAtendimentoId
                    this.local.dataRegistro = this.others.moment(item.dataRegistro).toDate()
                    this.local.vacina = {
                        id: item.vacinaId,
                        nome: item.vacinaNome,
                        abreviacao: item.vacinaAbreviacao,
                        sigla: item.vacinaSigla,
                        siglaNome: `${item.vacinaSigla} - ${item.vacinaNome}`,
                        siglaAbreviacao: `${item.vacinaSigla} - ${item.vacinaAbreviacao}`,
                        abreviacaoNome: `${item.vacinaAbreviacao} - ${item.vacinaNome}`,
                        siglaAbreviacaoNome: `${item.vacinaSigla} - ${item.vacinaAbreviacao} -
                            ${item.vacinaNome}`,
                    }
                    this.local.lote = item.lote
                            ? (typeof item.lote === 'object' && item.lote !== null ? item.lote.lote : item.lote)
                            : null;
                    this.local.grupoAtendimentoId = item.grupoAtendimentoId
                    this.local.grupoAtendimentoNome = item.grupoAtendimentoNome
                    this.local.doseId = item.doseId
                    this.local.doseNome = item.doseNome
                    this.local.observacao = item.observacao
                    this.local.estrategiaId = item.estrategiaId
                    this.local.estrategiaNome = item.estrategiaNome

                    this.$refs.RkmModal.show()
                }
            } else {
                Promise.all([
                    this.getUnidades(),
                    this.getSalasVacinacao(this.additionals.salaVacinacaoLogada.permiteAplicacao ? this.additionals.salaVacinacaoLogada.unidadeId : null),
                    this.getUsuario()
                ]).then(() => {
                    this.local.unidadeId = this.additionals.salaVacinacaoLogada.permiteAplicacao ? this.additionals.salaVacinacaoLogada.unidadeId : null
                    this.local.salaVacinacaoId = this.additionals.salaVacinacaoLogada.permiteAplicacao ? this.additionals.salaVacinacaoLogada.id : null
                    this.$refs.RkmModal.show()
                })
            }
        },
        handleUnidadeIdDeChange(value) {
            this.form.salasVacinacao = null
            this.form.doses = null
            this.form.estrategias = null
            this.local.salaVacinacaoId = null
            this.local.salaVacinacaoNome = null
            this.local.aplicador = null
            this.local.dataRegistro = null
            this.local.vacina = null
            this.local.lote = null
            this.local.doseId = null
            this.local.doseNome = null
            this.local.estrategiaId = null
            this.local.estrategiaNome = null

            if (value) {
                this.getSalasVacinacao(value)
            }
        },
        handleSalaVacinacaoIdChange() {
            this.form.doses = null
            this.form.estrategias = null
            this.local.aplicador = null
            this.local.dataRegistro = null
            this.local.vacina = null
            this.local.lote = null
            this.local.doseId = null
            this.local.doseNome = null
            this.local.estrategiaId = null
            this.local.estrategiaNome = null
        },
        handleVacinaInput() {
            this.form.doses = null
            this.form.estrategias = null
            this.local.lote = null
            this.local.doseId = null
            this.local.doseNome = null
            this.local.estrategiaId = null
            this.local.estrategiaNome = null
        },
        handleVacinaSelect(value) {
            this.local.estrategiaId = null
            this.local.lote = null

            this.getEstrategias(value.id)
            this.getDoses(value.id)
        },
        async getUnidades() {
            const request = {
                listar: 'unidades',
            }

            this.setLoading()

            try {
                const response = await this.repositories.registroVacinacao.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.unidades = Object.assign(response.data)

                if (this.form.unidades.length === 1) {
                    const selected = this.form.unidades[0]
                    this.local.unidadeId = selected.id
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getSalasVacinacao(unidadeId) {
            const request = {
                listar: 'salas_vacinacao',
                unidadeId: unidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.registroVacinacao.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.salasVacinacao = Object.assign(response.data)

                if (this.form.salasVacinacao.length === 1) {
                    const selected = this.form.salasVacinacao[0]
                    this.local.salaVacinacaoId = selected.id

                    if (this.aprazamento) {
                        this.getLotes(selected.id, this.local.vacina.id)
                    }
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getUsuario() {
            this.setLoading()
            this.repositories.registroVacinacao.list({
                listar: 'usuario'
            })
                .then(({ data }) => {
                    if(data) {
                        this.local.aplicador = {
                            id: data.id,
                            cidadaoNome: data.cidadaoNome,
                            cidadaoCns: data.cidadaoCns
                        }
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoes() {
            this.setLoading()
            this.repositories.fichaVacinacao.getOcupacoes({
                usuario_id: this.local.aplicador.id,
                sala_vacinacao_id: this.local.salaVacinacaoId,
            })
                .then(({ data }) => {
                    this.form.ocupacoes = data
                    if(data.length == 1) {
                        this.local.ocupacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {
            this.setLoading()
            this.repositories.fichaVacinacao.getEquipes({
                usuario_id: this.local.aplicador.id,
                sala_vacinacao_id: this.local.salaVacinacaoId,
            })
                .then(({ data }) => {
                    this.form.equipes = data
                    if(data.length == 1) {
                        this.local.equipeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getDoses(vacinaId, estrategiaId = null) {
            this.setLoading()

            const request = {
                origem: 'atualizacao',
                vacina_id: vacinaId,
                estrategia_id: estrategiaId,
            }

            this.repositories.fichaVacinacao.getDoses(request)
                .then(response => {
                    this.form.doses = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEstrategias(vacinaId) {
            this.setLoading()

            const request = {
                origem: 'atualizacao',
                vacina_id: vacinaId,
                registro_anterior: true,
            }

            this.repositories.fichaVacinacao.getEstrategias(request)
                .then(response => {
                    this.form.estrategias = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        hasAplicacao() {

            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const existe = this.model.registros.find(r => (!r.id || r.id !== this.local.id)
                        && r.vacinaId === this.local.vacina.id
                        && r.doseId === this.local.doseId
                        && r.estrategiaId === this.local.estrategiaId);

                    if (existe) {

                        const dataRegistro = this.others.moment(existe.dataRegistro).format('DD/MM/YYYY')

                        this.showConfirmation(
                            `O paciente já possui um registro idêntico com a mesma vacina, dose e estratégia na
                            data <strong>${dataRegistro}</strong>, com o motivo de
                            <strong>${existe.registroTipo == 'aplicacao' ? 'aplicação' : 'atualização'}</strong>.
                            Deseja realmente continuar?`, async () => { this.$nextTick().then(() => this.handleInclude()) }
                        )

                        return false
                    }

                    this.handleInclude()
                })
        },
        handleInclude() {

            const unidade = this.form.unidades.find(unidade => unidade.id === this.local.unidadeId)
            const salaVacinacao = this.form.salasVacinacao.find(salaVacinacao => salaVacinacao.id === this.local.salaVacinacaoId)
            const grupoAtendimento = this.form.gruposAtendimento.find(grupoAtendimento => grupoAtendimento.id === this.local.grupoAtendimentoId)
            const estrategia = this.form.estrategias.find(estrategia => estrategia.id === this.local.estrategiaId)
            const dose = this.form.doses.find(dose => dose.id === this.local.doseId)

            if (this.local.index !== null) {
                Object.assign(this.model.registros[this.model.registros.findIndex(r => r.id == this.local.id && r.registroTipo == 'atualizacao')], {
                    unidadeId: unidade.id,
                    unidadeNomeFantasia: unidade.nomeFantasia,
                    salaVacinacaoId: salaVacinacao.id,
                    salaVacinacaoNome: salaVacinacao.nome,
                    aplicadorId: this.local.aplicador.id,
                    aplicadorNome: this.local.aplicador.cidadaoNome,
                    ocupacaoId: this.local.ocupacaoId,
                    equipeId: this.local.equipeId,
                    turnoId: this.local.turnoId,
                    localAtendimentoId: this.local.localAtendimentoId,
                    dataRegistro: this.others.moment(this.local.dataRegistro).format('YYYY-MM-DD'),
                    vacinaId: this.local.vacina.id,
                    vacinaNome: this.local.vacina.nome,
                    vacinaAbreviacao: this.local.vacina.abreviacao,
                    vacinaSigla: this.local.vacina.sigla,
                    vacinaSiglaNome: `${this.local.vacina.sigla} - ${this.local.vacina.nome}`,
                    vacinaSiglaAbreviacao: `${this.local.vacina.sigla} - ${this.local.vacina.abreviacao}`,
                    vacinaAbreviacaoNome: `${this.local.vacina.abreviacao} - ${this.local.vacina.nome}`,
                    vacinaSiglaAbreviacaoNome: `${this.local.vacina.sigla} - ${this.local.vacina.abreviacao} -
                        ${this.local.vacina.nome}`,
                    lote: this.local.lote,
                    grupoAtendimentoId: grupoAtendimento?.id,
                    grupoAtendimentoNome: grupoAtendimento?.nome,
                    estrategiaId: estrategia?.id,
                    estrategiaNome: estrategia?.nome,
                    doseId: dose.id,
                    doseNome: dose.nome,
                    observacao: this.local.observacao,
                    registroTipo: 'atualizacao',
                })
            } else {
                this.model.registros.push({
                    unidadeId: unidade.id,
                    unidadeNomeFantasia: unidade.nomeFantasia,
                    salaVacinacaoId: salaVacinacao.id,
                    salaVacinacaoNome: salaVacinacao.nome,
                    aplicadorId: this.local.aplicador.id,
                    aplicadorNome: this.local.aplicador.cidadaoNome,
                    ocupacaoId: this.local.ocupacaoId,
                    equipeId: this.local.equipeId,
                    turnoId: this.local.turnoId,
                    localAtendimentoId: this.local.localAtendimentoId,
                    dataRegistro: this.others.moment(this.local.dataRegistro).format('YYYY-MM-DD'),
                    dataCadastro: this.others.moment(this.additionals.dataAtual).format('YYYY-MM-DD'),
                    vacinaId: this.local.vacina.id,
                    vacinaNome: this.local.vacina.nome,
                    vacinaAbreviacao: this.local.vacina.abreviacao,
                    vacinaSigla: this.local.vacina.sigla,
                    vacinaSiglaNome: `${this.local.vacina.sigla} - ${this.local.vacina.nome}`,
                    vacinaSiglaAbreviacao: `${this.local.vacina.sigla} - ${this.local.vacina.abreviacao}`,
                    vacinaAbreviacaoNome: `${this.local.vacina.abreviacao} - ${this.local.vacina.nome}`,
                    vacinaSiglaAbreviacaoNome: `${this.local.vacina.sigla} - ${this.local.vacina.abreviacao} -
                        ${this.local.vacina.nome}`,
                    lote: this.local.lote,
                    grupoAtendimentoId: grupoAtendimento?.id,
                    grupoAtendimentoNome: grupoAtendimento?.nome,
                    estrategiaId: estrategia?.id,
                    estrategiaNome: estrategia?.nome,
                    doseId: dose.id,
                    doseNome: dose.nome,
                    observacao: this.local.observacao,
                    registroTipo: 'atualizacao',
                })
            }

            if(this.local.index !== null) {
                this.$refs.RkmModal.hide()
            } else {
                this.local.vacina = null
                this.local.lote = null
                this.local.produtor = null
                this.local.estrategiaId = null
                this.local.doseId = null
                this.local.grupoAtendimentoId = null
                this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
            }
        },
        include() {
            this.hasAplicacao()
        },
        resetForm() {
            this.form.doses = null
            this.form.estrategias = null
            this.local.unidadeId = null
            this.local.unidadeNomeFantasia = null
            this.local.salaVacinacaoId = null
            this.local.salaVacinacaoNome = null
            this.local.aplicador = null
            this.local.ocupacaoId = null
            this.local.equipeId = null
            this.local.turnoId = this.getTurno()
            this.local.localAtendimentoId = this.enums.localAtendimento.UBS
            this.local.dataRegistro = null
            this.local.vacina = null
            this.local.lote = null
            this.local.produtorId = null
            this.local.produtorNome = null
            this.local.grupoAtendimentoId = null
            this.local.grupoAtendimentoNome = null
            this.local.doseId = null
            this.local.doseNome = null
            this.local.estrategiaId = null
            this.local.estrategiaNome = null
            this.local.observacao = null
        },
        autocompleteTextField(item) {

            let textField = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    textField = `${item.abreviacao}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    textField = `${item.sigla}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    textField = `${item.sigla} - ${item.nome}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    textField = `${item.sigla} - ${item.abreviacao}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    textField = `${item.abreviacao} - ${item.nome}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    textField = `${item.sigla} - ${item.abreviacao} - ${item.nome}`
                    break;

                default:
                    textField = `${item.nome}`
                    break;
            }

            return textField
        },
    },
    watch: {
        "local.salaVacinacaoId" () {

            if(this.local.aplicador?.id && this.local.salaVacinacaoId) {
                this.getOcupacoes()
                this.getEquipes()
            }
        },
        "local.aplicador" () {
            if(this.local.aplicador?.id && this.local.salaVacinacaoId && this.additionals.salaVacinacaoLogada.criaFichaAb) {
                this.getOcupacoes()
                this.getEquipes()
            }
        },
    },
    mixins: [ error, formats, repository, stringCase ],
    props: {
        additionals: { type: Object, required: true },
        disableAplicador: { type: Boolean, default: false },
        form: { type: Object, required: true },
        id: { type: [Number, String], default: null },
        model: { type: Object, required: true },
    },
}
</script>